// tabs/CostTab.jsx - Cost information tab
import React, { useState } from 'react';
import { Box, Grid, Stack, TextInput, Group, Text, NumberInput, Paper } from '@mantine/core';

const CostTab = ({ selectedLineId }) => {
  const [costData, setCostData] = useState({
    priceApprovedBy: '',
    dateTime: '',
    baseCost: 225.00,
    setupFeeBase: 0.00,
    lotChargeBase: 0.00,
    toolingBase: 0.00,
    extendedCostBase: 0.00,
    convCost: 225.00,
    setupFeeConv: 0.00,
    lotChargeConv: 0.00,
    toolingConv: 0.00,
    extendedCostConv: 0.00,
    currency: '',
    date: '12/30/1899',
    mrkUpDollar: 0.00,
    mrkUpPercent: 0.00
  });

  const handleChange = (field, value) => {
    setCostData(prev => ({ ...prev, [field]: value }));
  };

  return (
    <Box p="md">
      <Grid gutter="md">
        {/* Left Column - Price Approval */}
        <Grid.Col span={3}>
          <Stack spacing="xs">
            <Group spacing="xs" align="flex-end">
              <Text size="sm" fw={500} w={120}>Price Approved By:</Text>
              <TextInput
                value={costData.priceApprovedBy}
                variant="filled"
                size="sm"
                style={{ flex: 1 }}
                onChange={(e) => handleChange('priceApprovedBy', e.target.value)}
              />
            </Group>

            <Group spacing="xs" align="flex-end">
              <Text size="sm" fw={500} w={120}>Date/Time:</Text>
              <TextInput
                value={costData.dateTime}
                variant="filled"
                size="sm"
                style={{ flex: 1 }}
                onChange={(e) => handleChange('dateTime', e.target.value)}
              />
            </Group>
          </Stack>
        </Grid.Col>

        {/* Middle Left Column - Base */}
        <Grid.Col span={3}>
          <Paper withBorder p="sm">
            <Text size="sm" fw={500} ta="center" mb="sm">Base</Text>
            <Stack spacing="xs">
              <Group spacing="xs" align="flex-end">
                <Text size="sm" fw={500} w={90}>Base Cost:</Text>
                <NumberInput
                  value={costData.baseCost}
                  variant="filled"
                  size="sm"
                  style={{ flex: 1 }}
                  styles={{ input: { textAlign: 'right', fontWeight: 'bold', color: 'blue' } }}
                  decimalScale={2}
                  fixedDecimalScale
                  onChange={(value) => handleChange('baseCost', value)}
                />
                <Text size="sm" fw={500}>/EA ($)</Text>
              </Group>

              <Group spacing="xs" align="flex-end">
                <Text size="sm" fw={500} w={90}>Setup Fee:</Text>
                <NumberInput
                  value={costData.setupFeeBase}
                  variant="filled"
                  size="sm"
                  style={{ flex: 1 }}
                  styles={{ input: { textAlign: 'right', fontWeight: 'bold', color: 'blue' } }}
                  decimalScale={2}
                  fixedDecimalScale
                  onChange={(value) => handleChange('setupFeeBase', value)}
                />
              </Group>

              <Group spacing="xs" align="flex-end">
                <Text size="sm" fw={500} w={90}>Lot Charge:</Text>
                <NumberInput
                  value={costData.lotChargeBase}
                  variant="filled"
                  size="sm"
                  style={{ flex: 1 }}
                  styles={{ input: { textAlign: 'right', fontWeight: 'bold', color: 'blue' } }}
                  decimalScale={2}
                  fixedDecimalScale
                  onChange={(value) => handleChange('lotChargeBase', value)}
                />
              </Group>

              <Group spacing="xs" align="flex-end">
                <Text size="sm" fw={500} w={90}>Tooling:</Text>
                <NumberInput
                  value={costData.toolingBase}
                  variant="filled"
                  size="sm"
                  style={{ flex: 1 }}
                  styles={{ input: { textAlign: 'right', fontWeight: 'bold', color: 'blue' } }}
                  decimalScale={2}
                  fixedDecimalScale
                  onChange={(value) => handleChange('toolingBase', value)}
                />
              </Group>

              <Group spacing="xs" align="flex-end">
                <Text size="sm" fw={500} w={90}>Extended Cost:</Text>
                <NumberInput
                  value={costData.extendedCostBase}
                  variant="filled"
                  size="sm"
                  style={{ flex: 1 }}
                  styles={{ input: { textAlign: 'right', fontWeight: 'bold', color: 'blue' } }}
                  decimalScale={2}
                  fixedDecimalScale
                  onChange={(value) => handleChange('extendedCostBase', value)}
                />
              </Group>
            </Stack>
          </Paper>
        </Grid.Col>

        {/* Middle Right Column - Conv */}
        <Grid.Col span={3}>
          <Paper withBorder p="sm">
            <Text size="sm" fw={500} ta="center" mb="sm">Conv</Text>
            <Stack spacing="xs">
              <Group spacing="xs" align="flex-end">
                <Text size="sm" fw={500} w={90}>Conv Cost:</Text>
                <NumberInput
                  value={costData.convCost}
                  variant="filled"
                  size="sm"
                  style={{ flex: 1 }}
                  styles={{ input: { textAlign: 'right', fontWeight: 'bold', color: 'blue' } }}
                  decimalScale={2}
                  fixedDecimalScale
                  onChange={(value) => handleChange('convCost', value)}
                />
                <Text size="sm" fw={500}>/EA ($)</Text>
              </Group>

              <Group spacing="xs" align="flex-end">
                <Text size="sm" fw={500} w={90}>Setup Fee:</Text>
                <NumberInput
                  value={costData.setupFeeConv}
                  variant="filled"
                  size="sm"
                  style={{ flex: 1 }}
                  styles={{ input: { textAlign: 'right', fontWeight: 'bold', color: 'blue' } }}
                  decimalScale={2}
                  fixedDecimalScale
                  onChange={(value) => handleChange('setupFeeConv', value)}
                />
              </Group>

              <Group spacing="xs" align="flex-end">
                <Text size="sm" fw={500} w={90}>Lot Charge:</Text>
                <NumberInput
                  value={costData.lotChargeConv}
                  variant="filled"
                  size="sm"
                  style={{ flex: 1 }}
                  styles={{ input: { textAlign: 'right', fontWeight: 'bold', color: 'blue' } }}
                  decimalScale={2}
                  fixedDecimalScale
                  onChange={(value) => handleChange('lotChargeConv', value)}
                />
              </Group>

              <Group spacing="xs" align="flex-end">
                <Text size="sm" fw={500} w={90}>Tooling:</Text>
                <NumberInput
                  value={costData.toolingConv}
                  variant="filled"
                  size="sm"
                  style={{ flex: 1 }}
                  styles={{ input: { textAlign: 'right', fontWeight: 'bold', color: 'blue' } }}
                  decimalScale={2}
                  fixedDecimalScale
                  onChange={(value) => handleChange('toolingConv', value)}
                />
              </Group>

              <Group spacing="xs" align="flex-end">
                <Text size="sm" fw={500} w={90}>Extended Cost:</Text>
                <NumberInput
                  value={costData.extendedCostConv}
                  variant="filled"
                  size="sm"
                  style={{ flex: 1 }}
                  styles={{ input: { textAlign: 'right', fontWeight: 'bold', color: 'blue' } }}
                  decimalScale={2}
                  fixedDecimalScale
                  onChange={(value) => handleChange('extendedCostConv', value)}
                />
              </Group>
            </Stack>
          </Paper>
        </Grid.Col>

        {/* Right Column - Currency and Markup */}
        <Grid.Col span={3}>
          <Stack spacing="md">
            <Group spacing="xs" align="flex-end">
              <Text size="sm" fw={500} w={80}>Currency:</Text>
              <TextInput
                value={costData.currency}
                variant="filled"
                size="sm"
                style={{ flex: 1 }}
                onChange={(e) => handleChange('currency', e.target.value)}
              />
            </Group>

            <Group spacing="xs" align="flex-end">
              <Text size="sm" fw={500} w={80}>Date:</Text>
              <TextInput
                value={costData.date}
                variant="filled"
                size="sm"
                style={{ flex: 1 }}
                styles={{ input: { fontWeight: 'bold', color: 'blue' } }}
                onChange={(e) => handleChange('date', e.target.value)}
              />
            </Group>

            <Group spacing="xs" align="flex-end" mt="md">
              <Text size="sm" fw={500} w={80}>MrkUp($):</Text>
              <NumberInput
                value={costData.mrkUpDollar}
                variant="filled"
                size="sm"
                style={{ flex: 1 }}
                styles={{ input: { textAlign: 'right', fontWeight: 'bold', color: 'blue' } }}
                decimalScale={2}
                fixedDecimalScale
                onChange={(value) => handleChange('mrkUpDollar', value)}
              />
            </Group>

            <Group spacing="xs" align="flex-end">
              <Text size="sm" fw={500} w={80}>MrkUp(%):</Text>
              <NumberInput
                value={costData.mrkUpPercent}
                variant="filled"
                size="sm"
                style={{ flex: 1 }}
                styles={{ input: { textAlign: 'right', fontWeight: 'bold', color: 'blue' } }}
                decimalScale={2}
                fixedDecimalScale
                onChange={(value) => handleChange('mrkUpPercent', value)}
              />
            </Group>
          </Stack>
        </Grid.Col>
      </Grid>
    </Box>
  );
};

export default CostTab;